export enum Size {
  ExtraSmall = 'extra-small',
  Small = 'small',
  Medium = 'medium',
}
